/*
kavyareddy 02/2/2023 2699234404 Added Scheduler execution history
 */
import React, {useContext, useState} from 'react';
import LandingPage from '../../../Pages/LandingPage';
import {ThemeContext} from '../../../themes/ThemeProvider';
import SearchExecutionHistory from '../SchedulerExecutionHistory/SearchExecutionHistory/index';

const index = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <>
      <LandingPage
        title={'Scheduler Execution History'}
        showTabs={true}
        tabValue={tabValue}
        handleTabChange={handleChange}
      >
        <div className="global-field-dash-board">
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                {tabValue === 0 && <SearchExecutionHistory />}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
};
export default index;
